export const SET_PAGINATED_REPORTS_LOADED = "SET_PAGINATED_REPORTS_LOADED";

export const setPaginatedReportsLoaded = (paginatedReportsLoaded: boolean) => {
  return {
    paginatedReportsLoaded,
    type: SET_PAGINATED_REPORTS_LOADED
  };
};
 